import { lazy } from "react";
import { clearStudioView, setStudioView } from "../workspace/studio-views";
import type { SingingMomentsProps } from "./SingingMoments";
const SingingMoments = lazy(() => import("./SingingMoments").then((module) => ({ default: module.SingingMoments })));

/** The singing moments of a music clip on the storyboard step; any other production clears the slot. */
export function mountSingingMoments(projectId: string, props: SingingMomentsProps | null) {
  if (!props) return clearStudioView("singing-moments");
  setStudioView("singing-moments", `singing-moments:${projectId}`, <SingingMoments {...props} />);
}
